import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { CheckOutInfo } from '../types'

const useGetCheckOutInfo = (): [(ids: number[]) => Promise<CheckOutInfo>, Status<CheckOutInfo>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<CheckOutInfo>()

  const getCheckOutInfo = useCallback(
    (ids: number[]) => {
      return request({
        method: 'get',
        url: `/organizations/${organization.id}/check-ins/checkout-info`,
        config: {
          queryStringParameters: {
            ids: ids.join(','),
          },
        },
      })
    },
    [organization.id, request],
  )

  return [getCheckOutInfo, status]
}

export default useGetCheckOutInfo
